import { FormControl } from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectIcon,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { DROPDOWN_ITEM_CLASS, DROPDOWN_PANEL_CLASS } from '@/styles/floatingPanel';
import { sortBySortOrder } from '@/utils/sort';
import type { SurveyQuestionDetail } from '../../types/survey.types';

interface DropdownAnswerInputProps {
  options: SurveyQuestionDetail['options'];
  value: string;
  onChange: (value: string) => void;
  invalid: boolean;
}

export function DropdownAnswerInput({
  options,
  value,
  onChange,
  invalid,
}: DropdownAnswerInputProps) {
  const sortedOptions = sortBySortOrder(options);

  return (
    <FormControl>
      <Select<string>
        items={sortedOptions.map((option) => ({
          value: String(option.id),
          label: option.text,
        }))}
        value={value}
        onValueChange={(next) => onChange(next ?? '')}
      >
        <SelectTrigger aria-invalid={invalid || undefined}>
          <SelectValue placeholder="Select an option" />
          <SelectIcon />
        </SelectTrigger>
        <SelectContent className={DROPDOWN_PANEL_CLASS}>
          {sortedOptions.map((option) => (
            <SelectItem key={option.id} value={String(option.id)} className={DROPDOWN_ITEM_CLASS}>
              {option.text}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormControl>
  );
}
